import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveSuppliers, GetSuppliers } from "./index";

// Api's
import { supplierApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getSuppliersSaga(action: GetSuppliers) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			supplierApi.getSuppliersOrSupplierBranchesDomain,
			action.payload.request,
		);
		if (response.data.result) {
			yield put(saveSuppliers(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveSuppliers(null, true, resultError.messagesDataError));
		}
	}
}
